goog.provide('yext.location.ReferenceValue');
goog.provide('yext.location.ReferenceValueModel');

goog.require('yext');
goog.require('yext.autocomplete.Autocomplete');
goog.require('yext.location.helpers');
goog.require('yext.notify');

/**
 * ReferenceValue Field and Model with optional AJAX search functionality
 * @author MattJS (matt@yext.com)
 */

/**
 * @constructor
 */
yext.location.ReferenceValueModel = function(data) {
  this.set(data);
};

/**
 * Set the data for this field
 * @param {!Object} data
 */
yext.location.ReferenceValueModel.prototype.set = function(data) {
  this.value = data.value;
  this.indeterminate = data.indeterminate;
  this.label = data.label;
  this.selected = data.selected !== false;
};

/**
 * Return a label if the field has one, or its value
 */
yext.location.ReferenceValueModel.prototype.getLabel = function() {
  if (this.label) {
    return this.label;
  }
  return this.value;
};

/**
 * Set the field's label
 * @param {string} label
 */
yext.location.ReferenceValueModel.prototype.setLabel = function(label) {
  this.label = label;
};

/**
 * Set the field value and optionally emit and update if it has changed
 * @param {number|undefined} value
 */
yext.location.ReferenceValueModel.prototype.setValue = function(value) {
  if (value !== this.value || this.indeterminate) {
    this.value = value;
    this.indeterminate = false;
    this.emitUpdate();
  }
};

/**
 * Set the field indeterminate value and optionally emit and update if it has changed
 * @param {boolean} indeterminate
 */
yext.location.ReferenceValueModel.prototype.setIndeterminate = function(indeterminate) {
  if (indeterminate !== this.indeterminate) {
    this.indeterminate = indeterminate;
    this.emitUpdate();
  }
};

/**
 * Set the field selected value and optionally emit and update if it has changed
 * @param {boolean} selected
 */
yext.location.ReferenceValueModel.prototype.setSelected = function(selected) {
  if (selected !== this.selected) {
    this.selected = selected;
    this.emitUpdate();
  }
};

/**
 * @return {boolean} True if the field is empty
 */
yext.location.ReferenceValueModel.prototype.isEmpty = function() {
  return (this.value === '' || isNaN(this.value)) && !this.indeterminate;
};

/**
 * Returns a copy of the current model
 * @return {yext.location.ReferenceValueModel}
 */
yext.location.ReferenceValueModel.prototype.copy = function() {
  return new yext.location.ReferenceValueModel({
    value: this.value,
    indeterminate: this.indeterminate,
    label: this.label,
  });
};

/**
 * Emit an update using jQuery and the instance as context
 */
yext.location.ReferenceValueModel.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

/**
 * ReferenceValue field with search functionality
 * @constructor
 */
yext.location.ReferenceValue = function($ctx) {
  this.$ctx = $ctx;
  this.$field = $ctx.find('.js-reference-value-field').addBack().filter('.js-reference-value-field');
  this.$fieldEdit = $ctx.find('.js-reference-value-field-edit');
  this.entityTypeIds = this.$fieldEdit.data('entityTypeIds');
  this.$fieldValueInput = this.$field.find('.js-reference-value-field-value-input');
  this.$fieldSearcher = this.$field.find('.js-reference-value-field-searcher');
  this.$fieldSearcherInput = this.$field.find('.js-reference-value-field-searcher-input');
  this.$fieldSelection = this.$field.find('.js-reference-value-field-selection');
  this.$fieldValue = this.$ctx.find('.js-field-value');
  this.$indeterminateMsg = $ctx.find('.js-indeterminate-message');
  this.$fieldRow = $ctx.find('.js-reference-value-row');

  this.model = this.parseModel();
  this.searchRoute = this.$fieldSearcher.data('searchRoute');
  this.excludedValues = [];
  this.storeValue();

  this.setFieldValue();
  this.bindResetAll();
  this.bindFieldAutocomplete();
  this.bindClearSelection();
  this.bindCheckbox();
  this.bind();
};

/**
 * Set a list of values to exclude from the search. This is called by ReferenceValueList so that
 * a previously selected value does not show up
 *
 * @param {!Array} excludedValues List of values
 */
yext.location.ReferenceValue.prototype.excludeValues = function(excludedValues) {
  this.excludedValues = excludedValues;
};

/**
 * Parse the model from the DOM, translating string keys
 * @return {yext.location.ReferenceValueModel}
 */
yext.location.ReferenceValue.prototype.parseModel = function() {
  var data = this.$fieldEdit.data('fieldValue');
  data = {
    value: data['value'],
    indeterminate: data['indeterminate'],
    selected: true,
  };
  if (data.value) {
    data.label = this.$fieldSelection.find('.js-reference-value-field-selection-label').html();
  }
  this.timestamp = this.$fieldEdit.data('timestamp');
  return new yext.location.ReferenceValueModel(data);
};

/*
 * Sets a hidden input to the JSON value of this field
 */
yext.location.ReferenceValue.prototype.setFieldValue = function() {
  this.$fieldValue.val(yext.JSON.stringify(this.getData()));
};

/**
 * stores a copy of the model for reset
 */
yext.location.ReferenceValue.prototype.storeValue = function() {
  this.storedValue = this.model.copy();
};

/**
 * Set the field value
 */
yext.location.ReferenceValue.prototype.set = function(field) {
  // If the value returned is the same, leave the label in place
  if (field.value == this.model.value) {
    field.label = this.model.label;
  }

  this.model.set(field);
  if (field.timestamp != null) {
    this.timestamp = field.timestamp;
  }
  this.render();
};

/**
 * Reset the field value
 */
yext.location.ReferenceValue.prototype.reset = function() {
  this.set(this.storedValue);
  this.$fieldSearcherInput.val('');
};

/**
 * Bind the reset link in bulk edit mode
 */
yext.location.ReferenceValue.prototype.bindResetAll = function() {
  var self = this;

  this.$ctx.find('.js-reset-reference-value').click(function() {
    self.model.setIndeterminate(false);
  });
};

/**
 * Bind the checkbox
 */
yext.location.ReferenceValue.prototype.bindCheckbox = function() {
  var self = this;

  this.$checkbox = this.$ctx.find('input[type=checkbox]');
  if (this.$checkbox.length) {
    this.$checkbox.prop({
      indeterminate: this.model.indeterminate,
    });

    this.$checkbox.change(function() {
      if ($(this).prop('checked') || self.model.indeterminate) {
        self.model.setSelected(true);
        self.model.setIndeterminate(false);
      } else {
        self.model.setSelected(false);
      }
    });
  }
};

/**
 * Pass through the updated message
 */
yext.location.ReferenceValue.prototype.bind = function() {
  var self = this;
  $(this.model).on('updated', function() {
    self.render();
    self.setFieldValue();
    self.emitUpdate();
  });
};

/**
 * Render the state of the field based upon the model
 */
yext.location.ReferenceValue.prototype.render = function() {
  this.$indeterminateMsg.toggle(this.model.indeterminate);
  this.$fieldRow.toggle(!this.model.indeterminate);
  if (this.model.value) {
    this.$fieldSelection.find('.js-reference-value-field-selection-label')
      .html(this.model.getLabel());
  }
  this.$fieldSearcher.toggle(this.isEmpty());
  this.$fieldSelection.toggle(!this.isEmpty());

  if (this.$checkbox.length) {
    this.$checkbox.prop({
      checked: this.model.selected,
      indeterminate: this.model.indeterminate,
    });
  }
};

/**
 * Depending on if the field is searchable, focus on correct input
 */
yext.location.ReferenceValue.prototype.focus = function() {
  this.$fieldSearcherInput.focus();
};

/**
 * Bind autocomplete for this field if it is searchable
 */
yext.location.ReferenceValue.prototype.bindFieldAutocomplete = function() {
  var self = this;

  var $results = this.$field.find('.js-search-results');
  var $target = this.$field.find('.js-search-results-target');

  this.autocomplete = new yext.autocomplete.Autocomplete({
    $input: this.$fieldSearcherInput,
    $target: $target,
    $activeRegion: this.$fieldSearcher,
    source: function(request, response) {
      self.handleSearch(request, response);
    },
  });

  $(this.autocomplete).on('select', function(e, selection) {
    self.valueSelected(selection);
  });

  $(this.autocomplete).on('hide', function() {
    $results.hide();
  });

  $(this.autocomplete).on('show', function() {
    $results.show();
    $results.position({
      'my': 'left top',
      'at': 'left bottom',
      'of': this.$fieldSearcherInput,
    });
  });
};

/**
 * Call into doSearch and deal with error case.
 *
 * @param {string} request The search term
 * @param {function()} response A callback that is made once the search is complete
 */
yext.location.ReferenceValue.prototype.handleSearch = function(request, response) {
  var self = this;

  this.doSearch(request, function(results) {
    response(self.filterExcludedValues(results));
  }, function() {
    yext.notify.showError(yext.msg('Something went wrong when searching, please try again'));
  });
};

/**
 * The response method must be called must with an array of objects that minimally match
 * {label: '...', value: ...}.
 *
 * @param {string} request The search term
 * @param {function()} response A callback that is made once the search is complete
 * @param {function()} error A callback that is made when the search fails
 */
yext.location.ReferenceValue.prototype.doSearch = function(request, response, error) {
  var self = this;
  $.ajax({
    url: this.searchRoute,
    data: {'term': request, 'businessId': yext.businessId, 'entityTypeIds': self.entityTypeIds},
    success: function(results) {
      response(results);
    },
    error: function() {
      if (yext.isFunction(error)) {
        error();
      }
    },
  });
};

/**
 * Remove any values from the excludedValues list
 */
yext.location.ReferenceValue.prototype.filterExcludedValues = function(results) {
  var filtered = [];
  results.forEach(function(result) {
    if (this.excludedValues.indexOf(String(result.value)) === -1) {
      filtered.push(result);
    }
  }, this);
  return filtered;
};

/**
 * Triggered after a value is selected from autocomplete
 */
yext.location.ReferenceValue.prototype.valueSelected = function(selection) {
  var value = parseInt(selection.value);
  this.model.setLabel(selection.label);
  this.model.setValue(value);
};

/**
 * Bind the delete button
 */
yext.location.ReferenceValue.prototype.bindClearSelection = function() {
  var self = this;

  this.$fieldSelection.find('.js-clear-selection').click(function() {
    self.clear();
    setTimeout(function() {
      self.focus();
      self.autocomplete.search();
    }, 0);
  });
};

/**
 * Emit a message when the field is updated
 */
yext.location.ReferenceValue.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

/**
 * True if the field is empty
 */
yext.location.ReferenceValue.prototype.isEmpty = function() {
  return this.model.isEmpty();
};

/**
 * True if the field is indeterminate
 */
yext.location.ReferenceValue.prototype.isIndeterminate = function() {
  return !!this.model.indeterminate;
};

/**
 * Clear the fields value
 */
yext.location.ReferenceValue.prototype.clear = function() {
  this.model.setLabel(undefined);
  this.model.setValue(undefined);
  this.$fieldSearcherInput.val('');
};

/**
 * Get the field data with string keys
 */
yext.location.ReferenceValue.prototype.getData = function() {
  return {
    'value': this.model.value,
    'indeterminate': this.model.indeterminate,
    'timestamp': this.timestamp,
  };
};

/**
 * Remove all event handlers for garbage collection
 */
yext.location.ReferenceValue.prototype.destroy = function() {
  $(this).off();
  $(this.model).off();
};

/**
 * Returns the display value as an HTML string for the field
 *
 * @return {string}
 */
yext.location.ReferenceValue.prototype.getDisplayValue = function() {
  if (!this.isEmpty()) {
    return this.model.getLabel();
  }
  return yext.location.helpers.emptyFieldMessage();
};
